import { chains } from "./chains";
export const getRolesModId = (chainId, address) => `${chains[chainId].prefix}:${address.toLowerCase()}`;
export const getRoleId = (chainId, address, roleKey) => `${chains[chainId].prefix}:${address.toLowerCase()}:${roleKey}`;
